<template>
  <div class="chart" :id="id"></div>
</template>

<script setup>
import * as echarts from 'echarts';
// import "echarts-gl";
import { ref, onBeforeMount, onMounted, watch } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  options: {
    type: Object,
    default: null,
  },
});
let id = ref('chart-' + parseInt(Math.random() * 10000));
let myChart = null;
let dom = null;

const draw = () => {
  if (!props.options || !dom) return;
  myChart = echarts.init(dom);
  dom.setAttribute('_echarts_instance_', '');
  myChart.setOption(props.options, true);
};

watch(
  () => props.options,
  () => {
    draw();
  }
);

onMounted(() => {
  dom = document.getElementById(id.value);
  draw();
});
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
